// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1_3wD","alertIcon":"ConfirmModal_alertIcon__2yK9s"};